const VARIANTS = [
  {
    title: 'Классический',
    desc: 'Кочерга, совок, щипцы и подставка в традиционном исполнении. Проверенная временем функциональность, строгий дизайн.',
    specs: 'Базовая комплектация',
    imageUrl: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/768fa959d1278cf5d2ad9f3134aa7dac.jpeg',
  },
  {
    title: 'Кованый',
    desc: 'Художественная ковка с завитками и орнаментом. Каждый элемент — ручная работа мастера. Эксклюзивный декор для каминной зоны.',
    specs: 'Ручная ковка',
    imageUrl: 'https://readdy.ai/api/search-image?query=Artistic%20hand%20forged%20fireplace%20tool%20set%20with%20ornate%20scrollwork%20decorative%20floral%20pattern%20dark%20charcoal%20metal%20finish%20on%20a%20marble%20hearth%20warm%20fire%20glow%20background%20elegant%20craftsmanship%20realistic%20interior%20photography%20detailed%20texture&width=800&height=600&seq=var-fireplace-forged&orientation=landscape',
  },
  {
    title: 'Минималистичный',
    desc: 'Лаконичный набор из тонкого профиля. Чистые линии, ничего лишнего. Для современных интерьеров в стиле хай-тек или лофт.',
    specs: 'Современный стиль',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20modern%20fireplace%20tool%20set%20with%20slim%20stainless%20steel%20or%20dark%20charcoal%20thin%20profile%20poker%20shovel%20tongs%20and%20brush%20on%20a%20contemporary%20concrete%20hearth%20clean%20lines%20simple%20design%20modern%20living%20room%20bright%20natural%20daylight%20realistic%20interior%20photography&width=800&height=600&seq=var-fireplace-minimal&orientation=landscape',
  },
  {
    title: 'С дровницей',
    desc: 'Полноценный комплект: инструменты на подставке плюс вместительная дровница. Дрова всегда под рукой и выглядят аккуратно.',
    specs: 'Расширенная комплектация',
    imageUrl: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/fa8963556143399d955f708c85888380.jpeg',
  },
  {
    title: 'Индивидуальный',
    desc: 'Разработаем набор по вашему эскизу. Любая комплектация, уникальный рисунок, персональная гравировка. Единственный экземпляр.',
    specs: 'По вашему эскизу',
    imageUrl: 'https://readdy.ai/api/search-image?query=Custom%20designed%20unique%20fireplace%20tool%20set%20with%20personalized%20engraving%20bespoke%20wrought%20iron%20craftsmanship%20dark%20charcoal%20metal%20finish%20on%20a%20luxurious%20marble%20hearth%20warm%20fire%20glow%20background%20exclusive%20artisan%20work%20realistic%20interior%20photography%20high%20detail&width=800&height=600&seq=var-fireplace-custom&orientation=landscape',
  },
];

export default function VariantsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1400px' }}>
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Варианты исполнения
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Пять популярных моделей — от&nbsp;классики до&nbsp;индивидуального проекта. Подберём под&nbsp;стиль вашего&nbsp;камина
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {VARIANTS.map((variant, idx) => (
            <div
              key={variant.title}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden transition-all duration-400 hover:border-primary-200/50 flex flex-col animate-fade-in-up"
              style={{ animationDelay: `${idx * 0.08}s` }}
            >
              <div className="relative w-full h-52 md:h-60 overflow-hidden shrink-0">
                <img
                  src={variant.imageUrl}
                  alt={variant.title}
                  className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="p-5 md:p-6 flex flex-col flex-1">
                <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">{variant.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3 flex-1">{variant.desc}</p>
                <p className="text-xs font-medium text-accent-600 mb-4 bg-accent-100 inline-block self-start px-2.5 py-1 rounded-full">{variant.specs}</p>
                <a
                  href="https://wa.me/79174131562?text=%D0%97%D0%B4%D1%80%D0%B0%D0%B2%D1%81%D1%82%D0%B2%D1%83%D0%B9%D1%82%D0%B5!%20%D0%98%D0%BD%D1%82%D0%B5%D1%80%D0%B5%D1%81%D1%83%D0%B5%D1%82%20%D0%BA%D0%B0%D0%BC%D0%B8%D0%BD%D0%BD%D1%8B%D0%B9%20%D0%BD%D0%B0%D0%B1%D0%BE%D1%80."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm px-5 py-2.5 rounded-md transition-all duration-300 cursor-pointer text-center"
                >
                  Узнать стоимость
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}